"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LabelBox = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx4 = _interopRequireDefault(require("clsx"));
var _context = _interopRequireDefault(require("../Theme/context"));
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["classNames", "LabelComponent", "label", "children", "variant", "size", "className", "href", "onClick", "disableElevation", "TypographyProps", "Component", "style", "classes"],
  _excluded2 = ["classNames", "className", "labels", "LabelComponent", "LabelComponentProps", "LabelTitleComponent", "LabelTitleComponentProps", "inline", "Container", "LabelContainer", "LabelContainerProps"],
  _excluded3 = ["LabelComponent", "labelTitle", "LabelTitleComponent", "LabelTitleComponentProps", "LabelContainerProps"];
var defaultStyle = require("./../empty_css.js")["default"];
var Label = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useContext = (0, _react.useContext)(_context["default"]),
    _useContext$additiona = _useContext.additionalStyles,
    additionalStyles = _useContext$additiona === void 0 ? {} : _useContext$additiona,
    useStyle = _useContext.useStyle;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? additionalStyles.label || defaultStyle : _props$classNames,
    _props$LabelComponent = props.LabelComponent,
    LabelComponent = _props$LabelComponent === void 0 ? _Button["default"] : _props$LabelComponent,
    _props$label = props.label,
    label = _props$label === void 0 ? '' : _props$label,
    _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children,
    variant = props.variant,
    _props$size = props.size,
    size = _props$size === void 0 ? variant === 'inline' ? 'none' : 'default' : _props$size,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$href = props.href,
    href = _props$href === void 0 ? '' : _props$href,
    _props$onClick = props.onClick,
    onClick = _props$onClick === void 0 ? null : _props$onClick,
    _props$disableElevati = props.disableElevation,
    disableElevation = _props$disableElevati === void 0 ? true : _props$disableElevati,
    _props$TypographyProp = props.TypographyProps,
    TypographyProps = _props$TypographyProp === void 0 ? {} : _props$TypographyProp,
    _props$Component = props.Component,
    Component = _props$Component === void 0 ? !(href || onClick) ? 'span' : href ? 'a' : 'button' : _props$Component,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$classes = props.classes,
    classes = _props$classes === void 0 ? {} : _props$classes,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  if (!additionalStyles.label) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  return /*#__PURE__*/_react["default"].createElement(LabelComponent, Object.assign({}, rest, {
    ref: ref,
    Component: Component,
    variant: variant,
    size: 'label-' + size,
    className: (0, _clsx4["default"])(classNames.label, (0, _defineProperty2["default"])({}, classNames.disablePointerEvents, !(href || onClick)), className),
    TypographyProps: (0, _objectSpread2["default"])({
      variant: variant === 'inline' ? 'label-' + variant : 'label-' + size
    }, TypographyProps),
    disableElevation: disableElevation,
    style: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, !(href || onClick) ? {
      userSelect: 'inherit',
      WebkitUserSelect: 'inherit'
    } : {}), style),
    href: href,
    onClick: onClick,
    classes: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, classes), {}, {
      label: (0, _clsx4["default"])(classNames.buttonLabel)
    })
  }), children || label);
});
var LabelBox = exports.LabelBox = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useContext2 = (0, _react.useContext)(_context["default"]),
    _useContext2$addition = _useContext2.additionalStyles,
    additionalStyles = _useContext2$addition === void 0 ? {} : _useContext2$addition,
    useStyle = _useContext2.useStyle;
  var _props$classNames2 = props.classNames,
    classNames = _props$classNames2 === void 0 ? additionalStyles.label || defaultStyle : _props$classNames2,
    _props$className2 = props.className,
    className = _props$className2 === void 0 ? '' : _props$className2,
    _props$labels = props.labels,
    labels = _props$labels === void 0 ? [] : _props$labels,
    _props$LabelComponent2 = props.LabelComponent,
    LabelComponent = _props$LabelComponent2 === void 0 ? Label : _props$LabelComponent2,
    _props$LabelComponent3 = props.LabelComponentProps,
    LabelComponentProps = _props$LabelComponent3 === void 0 ? {} : _props$LabelComponent3,
    _props$LabelTitleComp = props.LabelTitleComponent,
    LabelTitleComponent = _props$LabelTitleComp === void 0 ? Label : _props$LabelTitleComp,
    _props$LabelTitleComp2 = props.LabelTitleComponentProps,
    LabelTitleComponentProps = _props$LabelTitleComp2 === void 0 ? {} : _props$LabelTitleComp2,
    _props$inline = props.inline,
    inline = _props$inline === void 0 ? false : _props$inline,
    _props$Container = props.Container,
    Container = _props$Container === void 0 ? 'div' : _props$Container,
    _props$LabelContainer = props.LabelContainer,
    LabelContainer = _props$LabelContainer === void 0 ? 'div' : _props$LabelContainer,
    _props$LabelContainer2 = props.LabelContainerProps,
    LabelContainerProps = _props$LabelContainer2 === void 0 ? {} : _props$LabelContainer2,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  if (!additionalStyles.label) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var DefaultLabelComponent = LabelComponent;
  var DefaultLabelComponentProps = LabelComponentProps;
  var DefaultLabelTitleComponent = LabelTitleComponent;
  var DefaultLabelTitleComponentProps = LabelTitleComponentProps;
  var DefaultLabelContainerProps = LabelContainerProps;
  return /*#__PURE__*/_react["default"].createElement(Container, Object.assign({}, rest, {
    ref: ref,
    className: (0, _clsx4["default"])(classNames.labelBox, (0, _defineProperty2["default"])({}, classNames.labelBoxInline, inline), className)
  }), (0, _toConsumableArray2["default"])(labels !== null && labels !== void 0 && labels.length ? labels.map(function (labelProps, i) {
    var _labelProps$LabelComp = labelProps.LabelComponent,
      LabelComponent = _labelProps$LabelComp === void 0 ? DefaultLabelComponent : _labelProps$LabelComp,
      _labelProps$labelTitl = labelProps.labelTitle,
      labelTitle = _labelProps$labelTitl === void 0 ? '' : _labelProps$labelTitl,
      _labelProps$LabelTitl = labelProps.LabelTitleComponent,
      LabelTitleComponent = _labelProps$LabelTitl === void 0 ? DefaultLabelTitleComponent : _labelProps$LabelTitl,
      _labelProps$LabelTitl2 = labelProps.LabelTitleComponentProps,
      LabelTitleComponentProps = _labelProps$LabelTitl2 === void 0 ? {} : _labelProps$LabelTitl2,
      _labelProps$LabelCont = labelProps.LabelContainerProps,
      LabelContainerProps = _labelProps$LabelCont === void 0 ? DefaultLabelContainerProps : _labelProps$LabelCont,
      restLabelProps = (0, _objectWithoutProperties2["default"])(labelProps, _excluded3);
    return /*#__PURE__*/_react["default"].createElement(LabelContainer, Object.assign({
      key: i
    }, LabelContainerProps), labelTitle ? /*#__PURE__*/_react["default"].createElement("div", {
      className: classNames.labelTitleContainer
    }, /*#__PURE__*/_react["default"].createElement(LabelTitleComponent, Object.assign({
      size: 'none',
      vairant: 'text',
      TypographyProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
        variant: 'label-label2'
      }, DefaultLabelTitleComponentProps.TypographyProps || {}), LabelTitleComponentProps.TypographyProps || {})
    }, DefaultLabelTitleComponentProps, LabelTitleComponentProps, {
      label: labelTitle
    }))) : null, /*#__PURE__*/_react["default"].createElement(LabelComponent, Object.assign({
      size: 'label1',
      variant: 'text'
    }, DefaultLabelComponentProps, restLabelProps, {
      className: (0, _clsx4["default"])((0, _defineProperty2["default"])({}, classNames.withoutStartIcon, !restLabelProps.startIcon && !DefaultLabelComponentProps.startIcon), restLabelProps.className || DefaultLabelComponentProps.className)
    })));
  }) : []));
});
var _default = exports["default"] = Label;